// tslint:disable: no-unused-expression
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'getPercentage' })
export class GetPercentagePipe implements PipeTransform {

  /* transform(): Pipe que devuelve el valor porcentual de un número con base en un total
    value: valor que corresponde a una fracción de un total
    total: valor que corresponde a el total
    max: Bandera para formatear el resultado si excede 100
  */
  transform(value: any, total: any, max: boolean = false): number {
    // ↓ verifica que el total sea un número
    if (!isNaN(total)) {
      // ↓ verifica que la fracción sea un número, sino lo convierte a 0
      isNaN(value) ? value = 0 : null;
      // result: Divide el valor entre el toal y lo multiplica por 100 para obtener el porcentaje
      let result: number = Math.round((value / total) * 100);
      // ↓ Si la bandera esta activa, devolverá el límite si el resultado lo excede
      if (max) { result > 100 ? result = 100 : null; }
      return result;
    } else { return 0; }
    // ↑ Devuelve 0 si el total no es un número
  }

}
